import React from 'react';
import {
  Button,
  Checkbox,
  Container,
  EmailInput,
  FormError,
  PhoneInput,
  TextInput,
  useErrorScroll,
  useForm,
} from 'library';

import './QuizPersonalForm.scss';

const QuizBasicForm = ({ onSubmit }) => {
  const { handleSubmit, registerField, formSubmitError } = useForm();
  useErrorScroll(formSubmitError);

  return (
    <div className="QuizPersonalForm">
      <FormError standalone error={formSubmitError} />
      <h1>Almost done! We just need a few final details...</h1>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Container row style={{ padding: 0 }}>
          <Container grid="6" style={{ padding: 0, paddingRight: 5 }}>
            <TextInput required label="First Name" placeholder="First" {...registerField('first_name')} />
          </Container>
          <Container grid="6" style={{ padding: 0, paddingLeft: 5 }}>
            <TextInput required label="Last Name" placeholder="Last" {...registerField('last_name')} />
          </Container>
        </Container>
        <EmailInput required label="Email Address" placeholder="your@email.com" {...registerField('email')} />
        <PhoneInput required label="Phone Number" placeholder="e.g. (###) ###-####" {...registerField('phone')} />
        <br />
        <br />
        <Checkbox
          className="QuizPersonalFormSmalltext"
          label="I agree that Hometap may call or text me using automated systems regarding my response and that data rates may apply"
          required
          {...registerField('phone_consent', 'checked')}
        />

        <Button type="submit">View Results</Button>
      </form>
    </div>
  );
};

export default QuizBasicForm;
